import { selector } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { type AccEmploymentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/accident';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const getAccEmploymentsSelector = selector<AccEmploymentDTO[]>({
    key: 'getAccEmploymentsSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);

        return await OnlineSalesUnauthenticated.getAccEmployments(
            jobNumber,
            sessionId,
            !isLoggedOn
        );
    }
});
